import { DataSet, englishDataset, pattern } from 'obscenity';

/** Hate-speech terms from the English preset (for category tagging). */
export const HATE_SPEECH_WORDS = new Set([
  'abeed',
  'abo',
  'africoon',
  'arabush',
  'boonga',
  'chingchong',
  'chink',
  'cuck',
  'dyke',
  'fag',
  'kike',
  'negro',
  'nigger',
  'rape',
  'retard',
  'spastic',
  'tranny',
]);

/**
 * Extra disguised patterns beyond the English preset + normalization pipeline.
 */
export function applyHateSpeechExtensions(
  dataset: DataSet<{ originalWord: string; category?: 'hate' | 'custom' }>,
): DataSet<{ originalWord: string; category?: 'hate' | 'custom' }> {
  return dataset
    .addAll(englishDataset)
    .addPhrase((phrase) =>
      phrase
        .setMetadata({ originalWord: 'n-word-variant', category: 'custom' })
        .addPattern(pattern`n1gg`)
        .addPattern(pattern`nigg`)
        .addPattern(pattern`nlgger`),
    )
    .addPhrase((phrase) =>
      phrase
        .setMetadata({ originalWord: 'f-slur-variant', category: 'custom' })
        .addPattern(pattern`f4g`)
        .addPattern(pattern`fagg`),
    )
    .addPhrase((phrase) =>
      phrase
        .setMetadata({ originalWord: 'k-slur-variant', category: 'custom' })
        .addPattern(pattern`k1k`)
        .addPattern(pattern`kik3`),
    );
}

export function categoryForOriginalWord(originalWord: string): 'profanity' | 'hate' | 'custom' {
  const lower = originalWord.toLowerCase();
  if (HATE_SPEECH_WORDS.has(lower) || lower.includes('slur') || lower.includes('n-word')) {
    return 'hate';
  }
  if (lower.includes('variant')) return 'custom';
  return 'profanity';
}
